/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Progress_Body_Weight_Latest_OldInputs */

const en_us2_progress_body_weight_latest_old = /** @type {(inputs: Progress_Body_Weight_Latest_OldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last logged ${i?.day}`)
};

const pt_br2_progress_body_weight_latest_old = /** @type {(inputs: Progress_Body_Weight_Latest_OldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último registro em ${i?.day}`)
};

const es_419_progress_body_weight_latest_old = /** @type {(inputs: Progress_Body_Weight_Latest_OldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último registro: ${i?.day}`)
};

const pt_pt2_progress_body_weight_latest_old = /** @type {(inputs: Progress_Body_Weight_Latest_OldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último registo em ${i?.day}`)
};

const fr_fr2_progress_body_weight_latest_old = /** @type {(inputs: Progress_Body_Weight_Latest_OldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière pesée le ${i?.day}`)
};

const de_de2_progress_body_weight_latest_old = /** @type {(inputs: Progress_Body_Weight_Latest_OldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt eingetragen: ${i?.day}`)
};

const it_it2_progress_body_weight_latest_old = /** @type {(inputs: Progress_Body_Weight_Latest_OldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultima registrazione il ${i?.day}`)
};

/**
* | output |
* | --- |
* | "Last logged {day}" |
*
* @param {Progress_Body_Weight_Latest_OldInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_body_weight_latest_old = /** @type {((inputs: Progress_Body_Weight_Latest_OldInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Body_Weight_Latest_OldInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_body_weight_latest_old(inputs)
	if (locale === "es-419") return es_419_progress_body_weight_latest_old(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_body_weight_latest_old(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_body_weight_latest_old(inputs)
	if (locale === "de-DE") return de_de2_progress_body_weight_latest_old(inputs)
	if (locale === "it-IT") return it_it2_progress_body_weight_latest_old(inputs)
	return en_us2_progress_body_weight_latest_old(inputs)
});
export { progress_body_weight_latest_old as "progress.body_weight_latest_old" }